// extracted by mini-css-extract-plugin
export default {"info":"ModalFlowPreview_info__1jtnL","buttonViewFlow":"ModalFlowPreview_buttonViewFlow__1JWpM"};